const POPULATE_PINOCODE_DATA = "POPULATE_PINOCODE_DATA";
const SET_PROPOSER_DETAILS = "SET_PROPOSER_DETAILS";
const SAVE_PROPOSER_DETAILS = "SAVE_PROPOSER_DETAILS";
const SET_SUB_OCCUPATION_DATA = "SET_SUB_OCCUPATION_DATA";
const SET_COUNTRY_DATA = "SET_COUNTRY_DATA";
const SET_PROPOSER_MASTER_DATA = "SET_PROPOSER_MASTER_DATA";
const SET_PROPOSER_REVIEW_DATA = "SET_PROPOSER_REVIEW_DATA";

export {
  POPULATE_PINOCODE_DATA,
  SET_PROPOSER_DETAILS,
  SAVE_PROPOSER_DETAILS,
  SET_SUB_OCCUPATION_DATA,
  SET_COUNTRY_DATA,
  SET_PROPOSER_MASTER_DATA,
  SET_PROPOSER_REVIEW_DATA
};
